import React, { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import service from "../../assets/images/resource/rpa_in_hr.png";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/RPA-b.png";
const RpaInHR = () => {
  pageTitle("RPA in HR");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here
    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed
    setFormData({
      name: "",
      email: "",
      subject: "",

      phone: "",
      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "Agentic RPA", slug: "/RPA-AI" },
    { id: 2, title: "Whatsapp Services", slug: "/Whatsapp-estore" },
    { id: 3, title: "Web Development", slug: "/Web-Development" },
    { id: 4, title: "Digital Consulting", slug: "/digital-consultancy" },
    { id: 5, title: "Data Engineering", slug: "/Data-Engineering" },
    { id: 6, title: "Data Science", slug: "/Data-Science" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/RPA-HR" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <Helmet>
        <title>RPA in HR | Digital Transformation</title>

        <meta
          name="description"
          content="Explore how Robotic Process Automation (RPA) in HR enhances operational efficiency, boosts revenue, and aids digital transformation."
        />
        <meta
          name="keywords"
          content="RPA, HR, Robotic Process Automation, Digital Transformation, Business Automation"
        />
        <meta
          property="og:title"
          content="RPA in HR | Digital Transformation"
        />
        <meta
          property="og:description"
          content="Learn how RPA in HR can transform your business, improve efficiency, and reduce costs."
        />
        <meta property="og:image" content={service} />
        <meta property="og:url" content="https://siw.sg/rpa-in-HR" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://siw.sg/rpa-in-HR" />
      </Helmet>
      <HeaderOne></HeaderOne>
      {/* <BreadCrumb></BreadCrumb> */}
      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${g1})` }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* <ul className="bread__crumb">
                    <li><Link to="/">Home</Link></li>
                    {pathnames.map((name, index) => (
                    <li key={index}>
                        <span> -</span>
                        <Link to={`/${pathnames.slice(0, index + 1).join('/')}`}>{name}</Link>
                    </li>
                    ))}
                </ul> */}
            {/* <h1 className="title">{pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home'}</h1> */}
          </div>
        </div>
      </section>
      <div className="service__details p_relative ">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="service__right">
                <figure>
                  <img src={service} alt="" />
                </figure>
                <h2>
                  RPA in <span>HR.</span>{" "}
                </h2>
                <p>
                  Robotic Process Automation (RPA) excels at automating high-volume, repetitive tasks that involve structured data and clear rules—exactly the kind of work found in HR operations. From managing employee records to handling payroll inputs, RPA reduces manual effort, improves accuracy, and ensures compliance with company policies and labour regulations. Because it is non-invasive, RPA can be deployed quickly on top of existing HR systems (HRIS, payroll, ATS) without major IT changes.

                  By implementing RPA, HR teams can streamline processes such as onboarding, attendance management, payroll preparation, and employee data updates. Routine tasks like copying data between systems, validating forms, or generating standard letters can be handled by bots, freeing HR professionals to focus on strategic work like talent development, engagement, and workforce planning. The result is faster turnaround time, fewer errors, and a better experience for both employees and HR staff.

                  As organizations continue their digital transformation, adopting RPA in HR is becoming essential for staying efficient, compliant, and competitive.
                </p>
                <h3>
                  <span>Key RPA Use Cases in HR</span>
                </h3>
                {/* <ul>
                  <li>
                    <strong>Employee Onboarding and Offboarding:</strong>
                    Automates collection and validation of documents, creation of user accounts, provisioning/deprovisioning of system access, and updating HRIS records
                  </li>
                  <li>
                    <strong>Payroll Preparation and Updates</strong>:
                    Extracts attendance and overtime data, validates inputs, updates payroll systems, and prepares files for payroll runs, reducing manual errors.
                  </li>
                  <li>
                    <strong>Leave and Attendance Management</strong>: Reads attendance logs, validates leave balances, updates systems, and sends notifications for approvals or exceptions.
                  </li>
                  <li>
                    <strong>Recruitment and Candidate Processing</strong>:
                    Parses CVs, updates applicant tracking systems, schedules interviews, sends standard emails, and updates candidate status across tools.
                  </li>
                  <li>
                    <strong>
                      Employee Data Maintenance and Compliance
                    </strong>
                    : Automatically checks for missing or expired documents (IDs, contracts, certificates), updates employee records, and supports audit and compliance reporting.
                  </li>
                  <li>
                    <strong>Training and Certification Tracking</strong>:
                    Monitors completion status for mandatory courses, updates learning records, and sends reminders to employees and managers.
                  </li>
                  <li>
                    <strong>HR Reporting and Analytics Support</strong>:
                    Pulls data from multiple systems to generate standard HR reports (headcount, attrition, leave usage, etc.) quickly and accurately.
                  </li>
                </ul> */}
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link to="/Emp_Onboarding " target="_blank"  className="blinking">
                        <i className="icon-04"></i> Employee Onboarding
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link to="/Emp_Attendance_Management" target="_blank"  className="blinking">
                        <i className="icon-04"></i> Employee Attendance Management
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link to="/Emp_Payroll_Preparation" target="_blank"  className="blinking">
                        <i className="icon-04"></i> Employee Payroll Preparation{" "}
                      </Link>
                    </li>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <li>
                      {" "}
                      <Link to="/Emp_HR_Analytics_Support" target="_blank"  className="blinking">
                        <i className="icon-04"></i> HR Reporting and Analytics Support
                      </Link>
                    </li>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="service__details__left">
                <div className="sidebar__widget">
                  <div className="all__service">
                    <h4>All Services</h4>
                  </div>
                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>
                <div
                  className=" sidebar__widget_network"
                  style={{ backgroundImage: `url(${basebg})` }}
                >
                  <h3>Contact Us For Any Require</h3>
                  <div className="services__icon">
                    <i className="icon-19"></i>
                  </div>
                  <p>Need help? Call us:</p>
                  <h4>+65 90059743</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne></FooterOne>
    </>
  );
};

export default RpaInHR;
